module.exports = __webpack_public_path__ + "static/media/klima-11.5a588b37.jpg";